import React from 'react';
import CRUDManager from '../../../../shared/components/crud/CRUDManager';
import { talukaConfig } from '../config/index';

export default function TalukaManagement() {
  return <CRUDManager config={talukaConfig} />;
}
